import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item", "displayRemaining", "toggleMore"];
  static values = { limit: Number };

  connect() {
    document.addEventListener("planima:DOMUpdated", this.eventDomUpdated);
    this.#reveal();
  }

  disconnect() {
    document.removeEventListener("planima:DOMUpdated", this.eventDomUpdated);
  }

  show(e) {
    e.preventDefault();

    this.itemTargets.forEach((item) => {
      item.classList.remove("hidden");
    });
    this.toggleMoreTarget.classList.add("hidden");
  }

  eventDomUpdated = () => {
    this.#reveal();
  };

  #reveal() {
    this.itemTargets.slice(0, this.limitValue).forEach((item) => {
      item.classList.remove("hidden");
    });

    if (this.itemTargets.length > this.limitValue) {
      this.toggleMoreTarget.classList.remove("hidden");
      this.displayRemainingTarget.innerText = `+${this.itemTargets.length - this.limitValue}`;
    }
  }
}
